module.exports = __webpack_public_path__ + "static/media/30gb.8fb0daaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/30gb.png
// module id = 78
// module chunks = 0